export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ResetApplicationDialog.json?hash=4fc768db59463dd88a8f5a53a210a982";